module.exports = __webpack_public_path__ + "static/media/card-sider.2e839584.png";